import {useEffect, useState} from "react";
import {useRouter} from "next/router";
import {updatePrimaryShop} from "@/services/shopServices";
import {getUserIdFromCookie, redirectTo} from "@/utils/Mobile/utils";
import {NAVIGATION_META_INFO_SPEEDY_SCAN, SPEEDY_SCAN_CONTEXT} from "@/utils/constants";
import Cookies from "js-cookie";

export const useSpeedyScanHook = () => {
    const router = useRouter();
    const [appDataState, setAppDataState] = useState();

    const THRESHOLD_HOLD_TIME = 2 * (1000 * 60);
    const SPEEDY_SCAN_TUNNEL_PAGES = [
        "/InStore/Purchase/Cart/Summary",
        "/InStore/Purchase/Cart/Shipping",
        "/InStore/Purchase/Order/Booking",
    ];

    useEffect(() => {
        // init the local state appDataState with appData
        if (typeof appData !== undefined && appDataState == undefined) setAppDataState(appData);
    }, [appDataState]);

    useEffect(() => {
        // Force script to wait the init process of appData.
        if (appDataState) {
            const speedyScanCookie = Cookies.get(NAVIGATION_META_INFO_SPEEDY_SCAN);
            if (typeof speedyScanCookie !== 'undefined' && speedyScanCookie !== "") {
                try {
                    const value = (JSON.parse(speedyScanCookie.match(/^\{.*\}/)[0])).value;
                    if (value === true) {
                        checkClientInShop();
                    }
                } catch (error) {
                    console.log('Error in check speedy scan process', error);
                }
            }
        }

    }, [appDataState]);
    const checkClientInShop = () => {
        const expirationDate = getCookieExpiration(NAVIGATION_META_INFO_SPEEDY_SCAN);
        if (expirationDate && (expirationDate <= THRESHOLD_HOLD_TIME)) {
            if ("geolocation" in navigator) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const {latitude, longitude} = position.coords;
                        const params = {
                            CalculationMethod: "ByLatLong",
                            CalculationParams: `${latitude},${longitude}`,
                            EveryShop: 1,
                            Context: SPEEDY_SCAN_CONTEXT,
                            shouldUpdateSpeedyScanNavigationMetaInfo: true,
                        }
                        updatePrimaryShop(getUserIdFromCookie(), params)
                            .then(response => {
                                const shopData = response.data;
                                // Handle redirection in funnel pages.
                                if (!shopData.primaryShop.eligibilityToScan?.isEligibleToScan
                                    && SPEEDY_SCAN_TUNNEL_PAGES.includes(router.asPath)) {
                                    redirectTo('/');
                                }
                            });
                    },
                    (error) => {
                        console.error("Error getting geolocation:", error);
                    }
                );
            } else {
                console.error("Error getting geolocation");
            }
        }
    }

    const getCookieExpiration = () => {
        const speedyScanCookie = Cookies.get(NAVIGATION_META_INFO_SPEEDY_SCAN);
        if (typeof speedyScanCookie !== 'undefined' && speedyScanCookie !== "") {
            const expires = (JSON.parse(speedyScanCookie.match(/^\{.*\}/)[0])).expires
            const expirationDate = new Date(expires.replace('+', ' '));
            const currentTime = new Date();
            return expirationDate.getTime() - currentTime.getTime();
        }
        return null;
    };

};
